var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-wrap items-center justify-center min-h-screen overflow-x-hidden overflow-y-auto p-4",class:_vm.$style['registration']},[_c('XConfirmInvitationForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }